import axios from 'axios';

class ApiService {
    constructor() {
        this._axios = axios;
        this._locale = 'ru';
        this._token = '';
        this._withAuth = false;
    }

    getAuthHeader() {
        return {'X-Authorization' : this._token};
    }

    getLangHeader() {
        return this._locale ? {'X-Localization' : this._locale} : {};
    }

    getBaseHeaders() {
        return {
            ...this.getLangHeader(),
            ...this.getAuthHeader()
        }
    }

    getResource(url) {
        return this._axios.get(this.getApiPrefix() + url)
    }

    postResource(url, params, headers) {
        if(this._withAuth) {
            headers = {...headers, ...this.getAuthHeader()}
        }

        if (headers) {
            return this._axios.post(this.getApiPrefix() + url, params, {headers: headers});
        } else {
            return this._axios.post(this.getApiPrefix() + url, params);
        }
    }

    getApiPrefix() {
        return '/api'
    }

    setLocale(locale) {
        this._locale = locale;

        return this;
    }

    setRequestHeaders(headers) {
        Object.keys(headers).map((key) => {
            this._axios.defaults.headers.common[key] = headers[key];
        })
    }

    setAuth(token) {
        this._token = token;
        this.enableAuth();
    }

    enableAuth() {
        this._withAuth = true;
    }

    disableAuth() {
        this._withAuth = false;
    }
}

export default ApiService;
